import React, { useEffect, useState } from "react";
import styles from "./TransferencePayment.module.css";
import { useDispatch, useSelector } from "react-redux";
import {Dialog} from 'primereact/dialog';

import { FileUpload } from "primereact/fileupload";
import tutorialImg1 from "../../assets/img/TutorialImg1.png";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import { useParams } from "react-router-dom";
import { Tag } from "primereact/tag";
import { useRef } from "react";
import { ProgressBar } from "primereact/progressbar";
import { uiActions } from "../../store/ui-slice";
import { getTokenInfo } from "../../utils/Guard";
import { GetOrdensById, UpdatePaymenMethod, UploadFileOrder } from "../../store/orden-store/orden-actions";
import { GetCourse } from "../../store/course-store/course-actions";

let callOnce = true;
let callOnce2 = true;

const TransferencePayment = ({ stepperRef }) => {
  const dispatch = useDispatch();
  const [amountDollar, setAmountDollar] = useState(0);
  const [amountRD, setAmountRD] = useState(0);
  const [count, setCount] = useState(1);
  const [totalSize, setTotalSize] = useState(0);
  const fileUploadRef = useRef(null);
  const course = useSelector((state) => state.course.course);
  const [isloaded, setIsload] = useState(false);
  const [billFile, setFile] = useState([]);
  const userInfo = getTokenInfo();
  const orden = useSelector((state) => state.orden.orden);
  const [showChooseButton, setShowChooseButton] = useState(true);
  const [showTutorial, setShowTutorial] = useState(true);
  const param = useParams();
  const toast = useRef(null);
  let amountToPay = "0";

  useEffect(() => {
    if (orden.id === undefined || orden.id === null || orden.id === 0) {
      if (callOnce2) {
        dispatch(GetOrdensById(userInfo.OrdenId, userInfo.Email));
        callOnce2 = false;
      }
    }
  }, [orden, userInfo, dispatch]);
  

  const CancelUrl =
    process.env.REACT_APP_MERCHANTID_URL + "courseInfo/" + param.courseid;
  const ApprovedUrl =
    process.env.REACT_APP_MERCHANTID_URL + "approvedtransaction";

  const DeclinedUrl =
    process.env.REACT_APP_MERCHANTID_URL + "deniedtransaction";

  let USDollar = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  let moneyFormat = new Intl.NumberFormat("en-US", {
    // style: "currency",
    currency: "USD",
    useGrouping: false,
    minimumFractionDigits: 2,
  });

    useEffect(() => {
      if (
        course === undefined ||
        course === null ||
        course.id === null ||
        course.id === undefined ||
        course.id === 0
      ) {
        if (
          userInfo !== undefined &&
          userInfo !== null &&
          userInfo.UserId !== null &&
          userInfo.UserId !== undefined &&
          param.courseid !== undefined &&
          callOnce
        ) {
          callOnce = false;
          dispatch(
            GetCourse(param.courseid, userInfo.UserId, "aulaaba.aba.org.do")
          );
        } else {
          if (callOnce) {
            callOnce = false;
            dispatch(GetCourse(param.courseid, 0, "aulaaba.aba.org.do"));
          }
        }
      }
    }, [course, dispatch, param.courseid, userInfo]);

  useEffect(() => {
    if (orden && orden.id !== undefined && orden.id !== 0) {
      if (
        orden.discount &&
        orden.discount.id !== undefined &&
        orden.discount.id !== 0 &&
        count > 0
      ) {
        let discount = 0;
        if (orden.discount.percentage) {
          discount =
            course.price * count * (orden.discount.discountPercentage / 100);
        }
        if (orden.discount.nominal) {
          discount = orden.discount.discountNominal * count;
        }
        const dollar = course.price * count;
        const rd = (dollar - discount) * 60;

        setAmountDollar(dollar - discount);
        setAmountRD(rd);
      } else {
        const dollar = course.price * count;
        const rd = dollar * orden.dollarRate;

        setAmountDollar(dollar);
        setAmountRD(rd);
      }
    }
  }, [orden, count]);

  amountToPay = moneyFormat.format(amountRD);

    useEffect(() => {
      if (
        orden &&
        orden.id !== undefined &&
        orden.id !== 0 &&
        course.id !== 0 &&
        course.id !== undefined &&
        course.id !== null
      ) {
        if (
          orden.discount &&
          orden.discount.id !== undefined &&
          orden.discount.id !== 0 &&
          count > 0
        ) {
          let discount = 0;
          if (orden.discount.percentage) {
            discount =
              course.price * count * (orden.discount.discountPercentage / 100);
          }
          if (orden.discount.nominal) {
            discount = orden.discount.discountNominal * count;
          }
          const dollar = (course.price * count) - discount;
          const rd = dollar * orden.dollarRate;
  
          setAmountDollar(dollar > 0 ? dollar : 0);
          setAmountRD(rd > 0 ? rd : 0);
        } else {
          const dollar = (course.price * count);
          const rd = dollar * orden.dollarRate;
  
  
          setAmountDollar(dollar > 0 ? dollar : 0);
          setAmountRD(rd > 0 ? rd : 0);
        }
      }
    }, [orden, count, course]);

  const formatFileName = (fileName) => {
    const maxLength = 5;
    const extension = fileName.substring(fileName.lastIndexOf("."));
    const nameWithoutExtension = fileName.substring(
      0,
      fileName.lastIndexOf(".")
    );

    if (nameWithoutExtension.length > maxLength) {
      return (
        nameWithoutExtension.substring(0, maxLength - 3) + ".." + extension
      );
    }

    return fileName;
  };

  return (
    <div>
      <Dialog header="Información" visible={showTutorial} style={{ width: "80%", height:"auto "}} onHide={() => setShowTutorial(false)}>
      <div className={styles.transferInfo}>
      <h2>Pasos a seguir para realizar el pago</h2>
                  <ol className="ordenTransferInfo">
                    <li>
                      Realizar la transferencia a una de nuestras cuentas:
                      <ul>
                        <li>
                          <strong>Banco BHD</strong>
                          <ul>
                            <li>
                              <strong>Cuenta Ahorro en dólares (US$):</strong>{" "}
                              0025893-0029
                            </li>
                            <li>
                              <strong>Cuenta Pesos Dominicanos</strong>{" "}
                              0025893-0070
                            </li>
                          </ul>
                        </li>
                      </ul>
                      <ul>
                        <li>
                          <strong>Banco Popular</strong>
                          <ul>
                            <li>
                              <strong>Cuenta Pesos Dominicanos</strong>{" "}
                              0114967-9
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                    <p className="ordenTransferInfo">
                    Ambas cuentas están a nombre de ABA <strong>RNC 401-053365</strong>, Banco Beneficiario: <strong>Banco BHD , S. A. </strong>
                    Swift: <strong>BCBHDOSDXXX </strong> o  Banco Beneficiario: <strong>Banco Popular Dominicano</strong>.  Favor incluir como
                    referencia del pago el número de orden asignado.
                  </p>
                    <li>
                      Hacer clic en el botón seleccionar al lado de comprobante de pago y subir el comprobante de pago de la transferencia.
                      
                  </li>
                  <img style={{width:"100%"}}src={tutorialImg1} alt="transferencia" border="0" />
                  </ol>
                 
                </div>
        </Dialog>
        <div style={{display: "flex"}}> 
      <h1 className={styles.formTitle}>Pago con transferencia bancaria</h1>
      <Button onClick={() => setShowTutorial(true)} className={styles.infoButton}>?</Button>
      </div>
      <div className={styles.facturationForm}>
      
        <Card className={styles.card}>
       
          <div className={styles.contentContainer}>
            <form className={styles.forms}>
              <div className={styles.column}>
                <label htmlFor="orderNumber">Número de orden</label>
                <h1>#{orden.id}</h1>
              </div>
              <div className={styles.column}>
                <label htmlFor="orderNumber">Tasa</label>
                <h1>{orden.dollarRate} RD$</h1>
              </div>

{
                    orden.discount && orden.discount.id !== 0 && (
                      <div className={styles.column}>
                    <label htmlFor="dolarAmount">Subtotal</label>
                    <h1>{"$" + course.price + " USD"}</h1>
                  </div>
                    )
                  }

{
                    orden.discount && orden.discount.id !== 0 && (
                      <div className={styles.column}>
                    <label htmlFor="dolarAmount">Descuento { "(" +orden.discountCode + ")"}</label>
                    <h1>{"$"+(course.price  - amountDollar).toFixed(2) + "USD "}</h1>
                  </div>
                    )
                  }
              <div className={styles.column}>
                <label htmlFor="dolarAmount">Total en dólares</label>
                <h1>{USDollar.format(amountDollar) + " USD"}</h1>
              </div>
              
              <div className={styles.column}>
                <label htmlFor="pesosAmount">Total en pesos</label>
                <h1>{USDollar.format(amountRD)}</h1>
              </div>
              <div className={styles.column}>
                <label>Comprobante de pago</label>
                <FileUpload
                  ref={fileUploadRef}
                  // itemTemplate={itemTemplate}
                  maxFileSize={1000000}
                  // onUpload={{onTemplateUpload}}
                  // onError={onTemplateClear}
                  // onClear={onTemplateClear}
                  // headerTemplate={headerTemplate}
                  // accept=".pdf"
                  // customUpload={true}
                  // onSelect={onSelectHandler}
                  mode="basic"
                  chooseLabel="Subir"
                  // chooseOptions={chooseOptions}
                  // uploadOptions={uploadOptions}
                  // cancelOptions={cancelOptions}
                  // emptyTemplate={<p className="m-0">Seleccione el documento a enviar.</p>}
                  className={styles.fileUpload}
                />
                
              </div>
              
            </form>
            <icon className={`pi pi-wallet ${styles.creditCardIcon}`}></icon>
          </div>
        </Card>

        <div
          style={{
            display: "flex",
            gap: "3%",
            marginTop: "3%",
            justifyContent: "space-between",
          }}
        >
          <Button
            className={styles.cardBackButton}
            label="Regresar"
            onClick={() => stepperRef.current.prevCallback()}
          />
          <Button
            className={styles.buttonPay}
            label="Finalizar"
            onClick={async () => {
              if (
                fileUploadRef.current &&
                fileUploadRef.current.getFiles().length > 0
              ) {
                const [file] = fileUploadRef.current.getFiles();
                await dispatch(UploadFileOrder(file, orden.id, userInfo.Email));
                await dispatch(UpdatePaymenMethod(orden.id, 2, userInfo.Email));
                window.location.href = "/transferenceRequested";
              } else {
                dispatch(
                  uiActions.showNotification({
                    status: "warning",
                    title: "Advertencia",
                    message: "Por favor adjunte un comprobante de pago.",
                  })
                );
              }
            }}
          />
        </div>
      </div>
    </div>
  );
};
export default TransferencePayment;
